export const EMPLOYEE_LIST_REQUEST = "EMPLOYEE_LIST_REQUEST";
export const EMPLOYEE_LIST_SUCCESS = "EMPLOYEE_LIST_SUCCESS";
export const EMPLOYEE_LIST_FAIL = "EMPLOYEE_LIST_FAIL";
export const EMPLOYEE_LIST_RESET = "EMPLOYEE_LIST_RESET";

export const EMPLOYEE_DETAILS_REQUEST = "EMPLOYEE_DETAILS_REQUEST";
export const EMPLOYEE_DETAILS_SUCCESS = "EMPLOYEE_DETAILS_SUCCESS";
export const EMPLOYEE_DETAILS_FAIL = "EMPLOYEE_DETAILS_FAIL";
export const EMPLOYEE_DETAILS_RESET = "EMPLOYEE_DETAILS_RESET";

export const EMPLOYEE_CREATE_REQUEST = "EMPLOYEE_CREATE_REQUEST";
export const EMPLOYEE_CREATE_SUCCESS = "EMPLOYEE_CREATE_SUCCESS";
export const EMPLOYEE_CREATE_FAIL = "EMPLOYEE_CREATE_FAIL";
export const EMPLOYEE_CREATE_RESET = "EMPLOYEE_CREATE_RESET";

export const EMPLOYEE_UPDATE_REQUEST = "EMPLOYEE_UPDATE_REQUEST";
export const EMPLOYEE_UPDATE_SUCCESS = "EMPLOYEE_UPDATE_SUCCESS";
export const EMPLOYEE_UPDATE_FAIL = "EMPLOYEE_UPDATE_FAIL";
export const EMPLOYEE_UPDATE_RESET = "EMPLOYEE_UPDATE_RESET";

export const EMPLOYEE_DELETE_REQUEST = "EMPLOYEE_DELETE_REQUEST";
export const EMPLOYEE_DELETE_SUCCESS = "EMPLOYEE_DELETE_SUCCESS";
export const EMPLOYEE_DELETE_FAIL = "EMPLOYEE_DELETE_FAIL";
export const EMPLOYEE_DELETE_RESET = "EMPLOYEE_DELETE_RESET";

export const EMPLOYEE_LIST_SIMPLE_REQUEST = "EMPLOYEE_LIST_SIMPLE_REQUEST";
export const EMPLOYEE_LIST_SIMPLE_SUCCESS = "EMPLOYEE_LIST_SIMPLE_SUCCESS";
export const EMPLOYEE_LIST_SIMPLE_FAIL = "EMPLOYEE_LIST_SIMPLE_FAIL";
export const EMPLOYEE_LIST_SIMPLE_RESET = "EMPLOYEE_LIST_SIMPLE_RESET";

export const EMPLOYEE_UPDATE_STATUS_REQUEST = "EMPLOYEE_UPDATE_STATUS_REQUEST";
export const EMPLOYEE_UPDATE_STATUS_SUCCESS = "EMPLOYEE_UPDATE_STATUS_SUCCESS";
export const EMPLOYEE_UPDATE_STATUS_FAIL = "EMPLOYEE_UPDATE_STATUS_FAIL";
export const EMPLOYEE_UPDATE_STATUS_RESET = "EMPLOYEE_UPDATE_STATUS_RESET";

export const EMPLOYEE_WORK_SCHEDULE_REQUEST = "EMPLOYEE_WORK_SCHEDULE_REQUEST";
export const EMPLOYEE_WORK_SCHEDULE_SUCCESS = "EMPLOYEE_WORK_SCHEDULE_SUCCESS";
export const EMPLOYEE_WORK_SCHEDULE_FAIL = "EMPLOYEE_WORK_SCHEDULE_FAIL";
export const EMPLOYEE_WORK_SCHEDULE_RESET = "EMPLOYEE_WORK_SCHEDULE_RESET";

export const EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST =
  "EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST";
export const EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS =
  "EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS";
export const EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL =
  "EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL";
export const EMPLOYEE_WORK_SCHEDULE_UPDATE_RESET =
  "EMPLOYEE_WORK_SCHEDULE_UPDATE_RESET";

export const EMPLOYEE_DOCUMENT_UPLOAD_REQUEST =
  "EMPLOYEE_DOCUMENT_UPLOAD_REQUEST";
export const EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS =
  "EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS";
export const EMPLOYEE_DOCUMENT_UPLOAD_FAIL =
  "EMPLOYEE_DOCUMENT_UPLOAD_FAIL";
export const EMPLOYEE_DOCUMENT_UPLOAD_RESET =
  "EMPLOYEE_DOCUMENT_UPLOAD_RESET";

export const EMPLOYEE_DOCUMENT_DELETE_REQUEST =
  "EMPLOYEE_DOCUMENT_DELETE_REQUEST";
export const EMPLOYEE_DOCUMENT_DELETE_SUCCESS =
  "EMPLOYEE_DOCUMENT_DELETE_SUCCESS";
export const EMPLOYEE_DOCUMENT_DELETE_FAIL =
  "EMPLOYEE_DOCUMENT_DELETE_FAIL";
export const EMPLOYEE_DOCUMENT_DELETE_RESET =
  "EMPLOYEE_DOCUMENT_DELETE_RESET";
